/**
 * Position API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Position { 
    /**
     * Organisation ID (key in db)
     */
    organisation_id?: string;
    /**
     * ID of the position (key in db)
     */
    id?: string;
    /**
     * External ID
     */
    external_id?: string;
    /**
     * Id of the Wbs
     */
    wbs?: string;
    /**
     * Type of the Position (enum)
     */
    type?: Position.TypeEnum;
    /**
     * InfoType (inner object contains additional information)
     */
    infoType?: object;
    /**
     * Name of the Position
     */
    name?: string;
    /**
     * Description of the Position
     */
    description?: string;
    /**
     * Category of the Position
     */
    category?: Position.CategoryEnum;
    /**
     * Metadata (inner object contains additional information)
     */
    metadata?: object;
    /**
     * Is the position assigned to an employee
     */
    vacancy?: boolean;
    /**
     * Department
     */
    department?: boolean;
    /**
     * UUID of the Assigned organisation
     */
    assigned?: string;
}
export namespace Position {
    export type TypeEnum = 'EMPLOYEE' | 'AI_AGENT';
    export const TypeEnum = {
        Employee: 'EMPLOYEE' as TypeEnum,
        AiAgent: 'AI_AGENT' as TypeEnum
    };
    export type CategoryEnum = 'MANAGER' | 'EXECUTOR';
    export const CategoryEnum = {
        Manager: 'MANAGER' as CategoryEnum,
        Executor: 'EXECUTOR' as CategoryEnum
    };
}


